import { useLoginStore } from '@lib/store';
import { AuthApi } from '@shared/api/rest';
import { RoutePaths, SessionStorageUtils } from '@shared/utils';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';

interface LogoutType {
  className?: string;
  mobile?: boolean;
}

export const Logout = (props: LogoutType) => {
  const loginStore = useLoginStore();

  const navigate = useNavigate();

  const handleLogout = async () => {
    SessionStorageUtils.removeIcaState();
    await AuthApi.logout();
    loginStore.clear();
    navigate(RoutePaths.login.onNavigate());
  };

  return (
    <div className={props.className} onClick={handleLogout}>
      {props.mobile && <div className='flex h-full items-center text-sm font-semibold text-[#a73f33] uppercase'>Log Out</div>}
      <div className={clsx('relative top-1 -right-1 flex h-6 w-15 items-center justify-center text-white', props.mobile && 'right-0.5 justify-end')}>
        <svg width='24' height='20' viewBox='0 0 24 20' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M16.097 10.643l-4.242 4.242c-.355.355-.931.355-1.286 0s-.355-.931 0-1.286l2.69-2.69h-12.351c-.502 0-.909-.407-.909-.909s.407-.909.909-.909h12.351l-2.69-2.691c-.355-.355-.355-.931 0-1.286s.931-.355 1.286 0l4.242 4.243.003.003.058.064.024.032.029.039.024.039.022.037.02.041.019.04.015.04.015.044.01.041.011.046.007.048.006.04.005.09-.005.09-.006.04-.007.048-.011.045-.011.042-.015.043-.015.041-.018.039-.02.041-.022.037-.024.039-.029.04-.024.032-.06.067zm6.085-9.734c0-.502.407-.909.909-.909s.909.407.909.909v18.182c0 .502-.407.909-.909.909s-.909-.407-.909-.909v-18.182z'
            fill='#fff'
          />
        </svg>
      </div>
      {!props.mobile && <div className='text-center text-sm font-semibold text-[#888] uppercase'>Log Out</div>}
    </div>
  );
};
